<template>
    <BaseModal
      name="doneСonsumptionModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="loadData"
      height="295"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('doneСonsumptionModal')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10" >
          <p class="mb-15 text-center fw-semi-bold">
            {{ dataLang['reg_company_44'] }}
          </p>
          <div class="d-flex flex-column align-items-center">
            <div class="d-flex justify-content-end gap-15">
              <div
                @click="$modal.hide('doneСonsumptionModal')"
                class="btn btn-sm btn-opposite px-20 py-10 rounded-10 d-flex text-uppercase align-items-center justify-content-center"
              >
                {{ dataLang['reg_company_55'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  </template>

  <script>
  import { mapActions, mapState, mapMutations } from 'vuex'
  import { VeTable } from 'vue-easytable'

  // TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
  export default {
    components: {
      VeTable
    },

    props: {
    },
    data() {
      return {
        typeOperation: false,
      }
    },
    methods: {
      loadData({params}) {
        console.log('12312321121',wdwdwwd );
        this.typeOperation = params?.types
      },
    },
    // computed: {
    //   computedTypeOperation() {
    //     return this.typeOperation
    //   }
    // },
    mounted() {},
    created() {},
    beforeDestroy() {},

    computed: {
      ...mapState('translationModule', ['dataLang'])
    }
  }
  </script>
